import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Question } from '../../App.styles';
import { Button, NavFooter } from '../../components';
import Result from '../../components/Result/Result';
import { ModelBrand } from '../../components/Result/Result.styles';
import {
  FlowStep,
  GlobalContext,
  StepperContext,
  updateFlowStep,
} from '../../contexts';
import { useTimeSpentMetric } from '../../hooks';
import { StepKey } from '../../types';
import { closeAmzModal, TestId } from '../../utils';
import getConfig, {
  betaSupportAvailable,
  VariantType,
} from '../shared/notCompatibleConfig';
import GetNotified from './GetNotified';
import { Body, Header, HeaderTitle } from './NotCompatibleAmazon.styles';

const NotCompatibleAmazon: FunctionComponent = () => {
  const { stepperData } = React.useContext(StepperContext);
  const { dispatch } = React.useContext(GlobalContext);
  const { brand, model } = stepperData;
  const { t } = useTranslation('common');

  useTimeSpentMetric('notCompatible');

  const variant: VariantType = betaSupportAvailable(model)
    ? VariantType.BETA_SUPPORT
    : VariantType.NOT_COMPATIBLE;
  const config = getConfig(variant);

  return (
    <Result stepKey={StepKey.NotCompatible}>
      <div className="row h-100 flex-column" data-testid={TestId.NotCompatible}>
        <div className="flex-grow-1">
          <div className="mt-2 mt-md-4">
            <Header className="mb-3">
              {config.headerIcon.amazon}
              <HeaderTitle as={Question}>{t(config.headerTitle)}</HeaderTitle>
            </Header>
          </div>

          <Body>
            <span>{t(config.description)}</span>
            {brand && model ? (
              <>
                <span>:</span>
                <ModelBrand>
                  {brand}, {model.model_name}.
                </ModelBrand>
                <GetNotified
                  brand={brand}
                  model={model.model_name}
                  variant={config.getNotified}
                />
              </>
            ) : (
              <span>.</span>
            )}
          </Body>
        </div>

        <NavFooter>
          <Button type="button" onClick={closeAmzModal}>
            {t('header.close')}
          </Button>
          <Button
            type="button"
            ghost
            onClick={() => {
              dispatch(
                updateFlowStep({ flowStep: FlowStep.compatibilityChecker })
              );
            }}
          >
            {t('header.back')}
          </Button>
        </NavFooter>
      </div>
    </Result>
  );
};

export default NotCompatibleAmazon;
